export const releaseNotes = {
  header: '',
  subHeader: '',

  releases: [
    {
      version: '2.3.0',
      date: '2026-09-18',
      quote: "The tab icon was React's logo the whole time. Nobody noticed because you can't see a pale blue atom on a pale grey tab.",
      new: [
        'Own icon set generated from the WAO Tools logo: SVG favicon, .ico, apple-touch, web manifest and Android maskable icon',
        'Social cards — shared links now show a 1200x630 WAO Tools card instead of a cropped square, and guides had no preview image at all',
        'Footer collapses on phones and tablets: one line with Privacy and the credit, expandable with a button',
        'Ad blocks at the end of each tool and at the close of each guide, on top of the existing Auto ads',
        'Google Analytics 4 support (inactive until a measurement ID is set)'
      ],
      improvements: [
        'Footer went from 220px to 44px on a phone — from 26% of the screen, permanently, to 5%',
        'Ad blocks collapse to nothing when there is no ad to show, instead of leaving an empty gap',
        'Privacy and Disclaimer links on the legal pages navigate without a full page reload',
        'npm run lint works again after being dead since ESLint dropped the old config format',
        'Dropped dead code: unused horizontal layout components and a leftover template asset'
      ],
      bugs: [
        'Fixed "BUY ME SOME COFFEES" on Contributors crashing instead of opening the donation dialog',
        'Fixed a source code comment being printed as visible text on the Beast and College pages',
        'Fixed the footer being fully covered by the bottom bar on Beast and College, which made the legal links impossible to tap',
        'Fixed the footer growing back to 160px on tablets in portrait, with no way to collapse it',
        'Fixed keyboard focus being invisible across the whole site — only 1 of 12 focusable elements showed any indicator',
        'Fixed the footer expand button showing no focus outline when reached with the keyboard',
        'Fixed a duplicated prop on the Azurite card switch in the Planner'
      ]
    },
    {
      version: '2.2.4',
      date: '2026-05-27',
      quote: 'Sun Tzu never mentioned hedge trimming, but here we are.',
      new: [
        'Garden Planner with save/load support',
        'Fragment Calculator for statues',
        'Smart Upgrade Advisor with weighted scoring',
        'Decoration Sets tracking with individual item levels',
        'Searchable dropdowns on all browse tabs'
      ],
      improvements: [
        'Statues split into God of War and Monster categories',
        'Search bar added to Garden Planner for quick navigation',
        'Subtle hover animations and tab transitions',
        'Tab order prioritizes planner tools first'
      ],
      bugs: ['Fixed number inputs showing leading zeros (e.g. 02 instead of 2)']
    },
    {
      version: '2.2.3',
      date: '2026-05-26',
      quote: 'The numbers were wrong, but the vibes were right. Now both are fixed.',
      new: ['Jewel slots now support 2 jewels per slot'],
      improvements: [],
      bugs: [
        'Fixed Army Size Limit showing as percentage instead of flat number on Equipment page',
        'Fixed wood RSS calculation using wrong field in Recruitment Speed calculator',
        'Fixed swapped wheat and wood icons in Recruitment Speed calculator',
        'Fixed 238.2% recruitment speed profile having incorrect tier times',
        'Fixed 230.7% recruitment speed profile giving lower time than 235.9%'
      ]
    },
    {
      version: '2.2.2',
      date: '2026-04-16',
      quote: 'Yes, we have a privacy policy. No, I did not read it either.',
      new: [
        'Added About page',
        'Added Contact page',
        'Added Privacy Policy page',
        'Added Terms of Service page',
        'Added Disclaimer page',
        'Added Guides section with dynamic routing',
        'Added sitemap generation',
        'Added robots.txt'
      ],
      improvements: [
        'Footer updated with links to new legal and info pages',
        'AdSense compliance: all required pages now in place',
        'Next.js 16 config cleaned up — removed unsupported keys',
        'Turbopack root config fixed to prevent wrong workspace detection'
      ],
      bugs: ['No bugs fixed this release, just compliance and config work!']
    },
    {
      version: '2.2.1',
      date: '2026-04-07',
      quote:
        'Knight of the old code, servant of the new. I have seen both sides, and I will be the bridge that unites them.',
      new: ['Stamina Pills Calculator added to Minitools.'],
      improvements: ['Nonee, just a new feature!'],
      bugs: ['No bugs fixed this time, just a shiny new feature!']
    },
    {
      version: '2.2.0',
      date: '2026-04-07',
      quote: 'Out with the old, in with the new. Everything looks the same but trust me, it is better.',
      new: [
        'Upgraded the entire app to the latest framework versions for better performance and future compatibility',
        'Every page now has an intro header with a description of the tool',
        'Dashboard page now has a welcome header block',
        'New cohesive color palette across the entire app'
      ],
      improvements: [
        'Fresh card design with colored top accent across all pages',
        'Homepage tool cards redesigned with cleaner layout and better descriptions',
        'All delete and clear buttons now look the same across every page',
        'Buttons are now the same height and properly spaced everywhere',
        'Save buttons are now green and consistent everywhere',
        'Wider layouts on Speeds, Colossus, Beast, Mystic and College pages',
        'Cleaner layout on Totem page with slot cards filling the full width',
        'Navigation menu updated with a cleaner active state style',
        'Packs page blocks now properly align on the left',
        'Tighter headers with less whitespace on all pages'
      ],
      bugs: [
        'Fixed security vulnerabilities by removing outdated components',
        'Fixed buttons appearing different sizes on some pages',
        'Fixed layout issues where content was not using the full available space',
        'Fixed Shield page now correctly showing server time in UTC and local time in your timezone',
        'Fixed Releases and Shields pages using outdated card style'
      ]
    },
    {
      version: '2.1.10',
      date: '2026-04-02',
      quote: 'I spent all my rubies upgrading jewels... now my troops are naked but at least they sparkle.',
      new: [
        'Added Jewel Upgrade Calculator page',
        'All 6 jewel slots: Ruby (Weapon & Helmet), Sapphire (Belt & Clothes), Topaz (Accessory & Boots)',
        'Level range calculator (Lv 1-40) to see upgrade costs and stat gains',
        'Resource cost overview showing Fragments and Essence needed per jewel',
        'All Jewels Overview panel with totals across all 6 slots',
        'Save & Reset functionality with browser storage'
      ],
      improvements: [
        'Accurate jewel data sourced from in-game values',
        'New diamond icon for Jewels in the navigation menu',
        'Clean jewel icon images for Ruby, Sapphire and Topaz'
      ],
      bugs: ['No bugs fixed this time, just a shiny new feature!']
    },
    {
      version: '2.1.9',
      date: '2025-08-21',
      quote: 'Is my shield still up? (The girl who checks 3 times before falling asleep)',
      new: ['Added new Shield Tracker Component'],
      improvements: [
        'Made the shield tracker available in the menu',
        'Introduced a new style for shields, contributors and release notes pages',
        'Code improvements'
      ],
      bugs: ['No bugs fixed this time, just a new feature!']
    },
    {
      version: '2.1.8',
      date: '2024-12-12',
      quote: 'Special Twat version',
      new: ['Added Ice Crown to Packs', 'Added Dashboard card to homepage'],
      improvements: ['Updated other packs', 'Updated Contributors', 'Updated menu badges'],
      bugs: ['Added Hospital level 40 to calculations for Sacred 3']
    },
    {
      version: '2.1.7',
      date: '2024-05-23',
      quote: '2 months later... Still waiting for a merge',
      new: ['Added Packs module.'],
      improvements: ['Some minor visual improvements for mobile.', 'Card shadows updated.'],
      bugs: ['Some minor bugs were fixed.', 'Title duplication in dashboard.']
    },
    {
      version: '2.1.6',
      date: '2024-03-01',
      quote: 'Waiting for a merge',
      new: [
        'Added Dashboard module.',
        'Sharing links for Database module.',
        'Updated realms merges list.',
        'Date to get Each castle Level in Planner Castle tab'
      ],
      improvements: [
        'Some minor visual improvements for mobile.',
        'Contributor page updated.',
        'Colossus, Beast and Hich College style updated.'
      ],
      bugs: ['Some minor bugs were fixed.', 'Fixed lv30 image for Weapong Equipment.']
    },
    {
      version: '2.1.5',
      date: '2024-02-23',
      quote: 'We will send you compensation: 100k food, 4x 1h Speeds. THANK YOU FOR PLAYING OUR GAME.',
      new: [
        'Planner v3 upgraded.',
        'Added Castle tab for Planner.',
        'Undead layout add on Troops module.',
        'Changed 404 page.',
        'Added missing date in Azurite module.'
      ],
      improvements: [
        'Some minor visual improvements for mobile.',
        'Contributor page updated.',
        'Colossus, Beast and Hich College style updated.'
      ],
      bugs: ['Some minor bugs were fixed.', 'Fixed lv30 image for Weapong Equipment.']
    },
    {
      version: '2.1.4',
      date: '2024-02-13',
      quote: 'Onare, what is the EW trick? (The guy who has 3 years playing)',
      new: [
        'Added Tips N Tricks module.',
        'Added Elite War layouts in Troops module.',
        'Added sharing option for Troops layouts. '
      ],
      improvements: [
        'Some minor visual improvements for mobile.',
        'Remove Checkboxs for Realm Merges, Building and Artifacts tables.'
      ],
      bugs: ['Angel Limit not showing in Accessory Enhancements.', 'EW Preset Enhancement showing RI enhance in Boots.']
    },
    {
      version: '2.1.3',
      date: '2024-02-07',
      quote: "Anyone SOS? (The ones who don't want to drop the shield) My Royal Challenge hit.",
      new: ['Equipment module v2.', 'Release Notes added.', 'New loading spinner was added.'],
      improvements: ['Some minor visual improvements for mobile.', 'Cleaned unused data from previous versions.'],
      bugs: ['Some minor bugs were fixed.']
    },
    {
      version: '2.1.2',
      date: '2024-02-02',
      quote: "My SOS Button didn't work, I'll text Support. (Hahaha!)",
      new: ['Artifact module v2.'],
      improvements: [
        'Some minor visual improvements.',
        'Updated some styles in Troops module.',
        'Updated Home module for coming soon, under development and new info.'
      ],
      bugs: ['Some minor bugs were fixed.']
    },
    {
      version: '2.1.1',
      date: '2024-01-26',
      quote: 'Dont stop the coding! Keep making coffee.',
      new: ['Minitools module migrated', 'Added WaoTools v2 logo.'],
      improvements: [
        'Disabling modules not finished or tbd in Home.',
        'Updated Home module for coming soon, under development and new info.'
      ],
      bugs: ['Key properties were fixed on some pages.']
    },
    {
      version: '2.0.9',
      date: '2024-01-24',
      quote: 'Almost in production!',
      new: ['Contributors module was finished.'],
      improvements: [
        'Some minor visual improvements.',
        'Restyle azurite page.',
        'Restyle Database page.',
        'Remove paper from planner.'
      ],
      bugs: ['Vertical layout rendering.', 'Remove double troop card.']
    },
    {
      version: '2.0.8',
      date: '2024-01-20',
      quote: "This is for the guy who always says: I've never been zeroed.",
      new: ['Totems and Realms Modules migrated.'],
      improvements: ['Some minor visual improvements.'],
      bugs: ['Some minor bugs were fixed.']
    },
    {
      version: '2.0.7',
      date: '2024-01-11',
      quote: 'Check waotools before asking.',
      new: ['Speed module Reworked.', 'Building module migrated.'],
      improvements: ['Some minor visual improvements.'],
      bugs: ['Some minor bugs were fixed.']
    },
    {
      version: '2.0.6',
      date: '2024-01-09',
      quote: 'I won’t be impressed with technology until I can download food.',
      new: ['Mystic College module migrated.', 'High College module migrated.'],
      improvements: ['Some minor visual improvements.'],
      bugs: ['Some minor bugs were fixed.']
    },
    {
      version: '2.0.5',
      date: '2024-01-03',
      quote: 'Anyone ruins? Says the guy when there are only 3 minutes left for reset.',
      new: ['Colossus module migrated.', 'Database module migrated.'],
      improvements: ['Some minor visual improvements.'],
      bugs: ['Some minor bugs were fixed.']
    },
    {
      version: '2.0.4',
      date: '2024-01-02',
      quote: 'Can I have reins? The guy with 1 march and 10m BP.',
      new: ['Beast Talents Simulator migrated.', 'Beast Skill module migrated.'],
      improvements: ['Some minor visual improvements.'],
      bugs: ['Some minor bugs were fixed.', 'Fixed linear progress in mobile view.', 'Troops layout fixed for mobiles.']
    },
    {
      version: '2.0.3',
      date: '2023-12-29',
      quote: 'Yes, 2024 and we keep playing this. schedule a meeting with the psychologist',
      new: ['Added Troops Module.'],
      improvements: ['Some minor visual improvements.'],
      bugs: ['Some minor bugs were fixed.', 'Fixed linear progress in mobile view.']
    },
    {
      version: '2.0.2',
      date: '2023-12-23',
      quote:
        'The top players haters on WC: Why can you let people play? I will leave this realm! This game was my life!',
      new: ['Azurite calculator migrated.', 'New look for homepage.', 'Added authors.'],
      improvements: ['Some minor visual improvements.'],
      bugs: ['Some minor bugs were fixed.']
    },
    {
      version: '2.0.1',
      date: '2023-12-17',
      quote: 'Here we go again.',
      new: [
        'Planner module was migrated and reworked.',
        'Added Home module and Menu',
        'Added readme and contribution files.'
      ],
      improvements: ['Some minor visual improvements.'],
      bugs: ['Some minor bugs were fixed.', 'Fixed linear progress in mobile view.']
    }
  ]
}
